module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"product_name":{"label":"Product name","placeholder":"Write product name here"},"price":{"label":"Price","placeholder":"0"}}}')
  delete Component.options._Ctor
}
